interface IResultField {
  label: string;
  value: string;
}

export enum EBlockType {
  Deposit = 'deposit',
  Mortgage = 'mortgage',
}

export interface IResultBlock {
  type: EBlockType;
  // TODO: В 3-ей итерации убрать поле title - есть тип блока, из него вытащить название. Обратная совместимость на момент релиза
  title: string;
  price: IResultField;
  time: IResultField;
}
